import { render, staticRenderFns } from "./VForm.vue?vue&type=template&id=6667855a&"
import script from "./VForm.vue?vue&type=script&lang=js&"
export * from "./VForm.vue?vue&type=script&lang=js&"
import style0 from "./VForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6667855a')) {
      api.createRecord('6667855a', component.options)
    } else {
      api.reload('6667855a', component.options)
    }
    module.hot.accept("./VForm.vue?vue&type=template&id=6667855a&", function () {
      api.rerender('6667855a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VForm.vue"
export default component.exports